import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "3", height: "9", x: "7", y: "7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "3", height: "5", x: "14", y: "7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Trello";
const Trello = memo(themed(Icon));
export {
  Trello
};
//# sourceMappingURL=trello.js.map
